

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class IntegratorMappingInfo_ManagedObject

class IntegratorMappingInfo_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: type
    set type(value:string) {
        this.setValueForKey(value, 'type');
    }
    get type():string {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():string {
        return this.primitiveValueForKey('type');
    }

    // Relationship: configs
    protected _configs:MIOManagedObjectSet = null;
    get configs():MIOManagedObjectSet {
        return this.valueForKey('configs');
    }
    addConfigsObject(value:IntegratorConfig) {
        this._addObjectForKey(value, 'configs');
    }
    removeConfigsObject(value:IntegratorConfig) {
        this._removeObjectForKey(value, 'configs');
    }

    // Relationship: entityMappings
    protected _entityMappings:MIOManagedObjectSet = null;
    get entityMappings():MIOManagedObjectSet {
        return this.valueForKey('entityMappings');
    }
    addEntityMappingsObject(value:IntegratorMappingEntity) {
        this._addObjectForKey(value, 'entityMappings');
    }
    removeEntityMappingsObject(value:IntegratorMappingEntity) {
        this._removeObjectForKey(value, 'entityMappings');
    }

    // Relationship: keyMappings
    protected _keyMappings:MIOManagedObjectSet = null;
    get keyMappings():MIOManagedObjectSet {
        return this.valueForKey('keyMappings');
    }
    addKeyMappingsObject(value:IntegratorMappingKey) {
        this._addObjectForKey(value, 'keyMappings');
    }
    removeKeyMappingsObject(value:IntegratorMappingKey) {
        this._removeObjectForKey(value, 'keyMappings');
    }

    // Relationship: ruleMappings
    protected _ruleMappings:MIOManagedObjectSet = null;
    get ruleMappings():MIOManagedObjectSet {
        return this.valueForKey('ruleMappings');
    }
    addRuleMappingsObject(value:IntegratorMappingRule) {
        this._addObjectForKey(value, 'ruleMappings');
    }
    removeRuleMappingsObject(value:IntegratorMappingRule) {
        this._removeObjectForKey(value, 'ruleMappings');
    }

    // Relationship: valueTypes
    protected _valueTypes:MIOManagedObjectSet = null;
    get valueTypes():MIOManagedObjectSet {
        return this.valueForKey('valueTypes');
    }
    addValueTypesObject(value:IntegratorMappingValueType) {
        this._addObjectForKey(value, 'valueTypes');
    }
    removeValueTypesObject(value:IntegratorMappingValueType) {
        this._removeObjectForKey(value, 'valueTypes');
    }
}
